/**
 * Component per als htmlblocks del webpack.
 * Tenen la classe ".component-htmlblcok".
 * Pot haver-hi més d'un a la pàgina.
 *
 * Assumes jQuery is loaded.
 */



function init ()
{
    const jqComponents = $('.component-htmlblock');
    const jqAllVideos = jqComponents.find('video');

    jqComponents.each(function () {
        const jqWrapper = $(this);
        const jqVideo = jqWrapper.find('video');
        const jqVideolandplay = jqWrapper.find('.btvideolandplay');
        if (jqVideo.length > 0) {
            jqVideolandplay.click(function (e) {
                jqVideo[0].play();
            });
            jqVideo.on('play', function (e) {
                jqVideolandplay.css("display", "none");
                jqVideo.attr("controls", true);
                const currentVideo = e.target;
                jqAllVideos.each(function () {
                    if (this != currentVideo)  {
                        this.pause();
                    }
                });
            });
            jqVideo.on('pause', function (e) {
                jqVideolandplay.css("display", "block");
                jqVideo.attr("controls", false);
            });
        }
    });

}

export default {
    init,
}

$(".owl-carousel-htmlblock").owlCarousel({
    loop: true,
    autoplay: false,
    items: 1,
    nav: false,
    dots: true,
    autoplayHoverPause: true,
    animateOut: 'slideOutUp',
    animateIn: 'slideInUp'
});